<template>
  <div class="mycourses-wrapper">
    <section class="sajilo-section">
        <div class="container">
          <div class="mycourses__list courses__list">
            
            <template v-if="coursesubscribed && coursesubscribed.length > 0">
              <v-row >
                <v-col cols="12" sm="6" lg="4" >
                  <article class="featured_courses__heading-content">
                    <h2 class="featured_courses__title">My <span>Courses</span></h2>
                    <!-- <button class="button button_md button_blue">View All Courses</button> -->
                    <span class="icon-zigzag-line-alt"></span>
                  </article>
                </v-col>

                <v-col cols="12" sm="6" lg="4" v-for="(course,i) in coursesubscribed" :key="i">
                  <div class="featured_courses_card_wrapper">
                    <CourseCard :mycourse="true" :course="course"></CourseCard>
                  </div>
                </v-col>
              </v-row>
            </template>
            <template v-else-if="!coursesubscribed || coursesubscribed.length === 0 || coursesubscribed === null">
               <v-alert
                  dense
                  border="left"
                  type="warning"
                >
                  Sorry you haven't bought any courses yet so you have no course to view in your dashboard. Check out the following feature courses below.
                </v-alert>
              <v-row >
                <v-col cols="12" sm="6" lg="4" >
                  <article class="featured_courses__heading-content">
                    <h2 class="featured_courses__title">Feature <span>Courses</span></h2>
                    <!-- <button class="button button_md button_blue">View All Courses</button> -->
                    <span class="icon-zigzag-line-alt"></span>
                  </article>
                </v-col>

                <v-col cols="12" sm="6" lg="4" v-for="(course,i) in courses.results" :key="i">
                  <div class="featured_courses_card_wrapper">
                    <CourseCard :mycourse="true" :course="course"></CourseCard>
                  </div>
                </v-col>
              </v-row>
            </template>
            <div class="course-list__pagination" v-if="courses.page">
              <div class="text-right">
                <CoursePagination class="justify-end"></CoursePagination>
              </div>
            </div>
          </div>
        </div>
    </section>
    <KeepLearning></KeepLearning>
  </div>
</template>

<script>
import CourseCard from '@/components/Courses/CourseCard';
import CoursePagination from "@/components/Courses/CoursePagination.vue";
import KeepLearning from "@/components/KeepLearning/KeepLearning.vue";
export default {
  name: 'MyCourse',
  data () {
    return {
      coursesubscribed: {},
      courses: [],
      is_status: true,
    }
  },
  components: {
    CourseCard,
    CoursePagination,
    KeepLearning
  },
  
  async mounted () {
      await this.$store.dispatch('getCourseSubscibed').then(res => {
          this.coursesubscribed = res
          // console.log(res)
          this.is_status = true
          if(res.length === 0) {
            this.coursesubscribed = null
          }
      })
      await this.$store.dispatch('getFeatureCourses').then(res => {
        this.courses=  res;
        this.is_status = false
        // console.log(this.courses)
      })
  },
}
</script>

